module.exports = __webpack_public_path__ + "media/images/emblems/Meierskappel_LU-606a2f1c88bbd83ff237d0a6386f5f7c.png";